import { createRouter, createWebHistory } from "vue-router";
import { nextTick } from "vue";
import AOS from "aos";

import HomeOne from "@/views/pages/public/home/index-one.vue";

import comingSoon from "@/views/pages/system/maintenance/coming-soon.vue";
import underConstruction from "@/views/pages/system/maintenance/under-construction.vue";
import error404 from "@/views/pages/system/error/error-404.vue";
import error500 from "@/views/pages/system/error/error-500.vue";

import instructorIndex from "@/views/pages/dashboard/instructor/pages/instructor-index.vue";
import instructorDashboard from "@/views/pages/dashboard/instructor/pages/instructor-dashboard.vue";
import instructorProfile from "@/views/pages/dashboard/instructor/pages/instructor-profile.vue";
import instructorCourse from "@/views/pages/dashboard/instructor/pages/instructor-course.vue";
import InstructorQuiz from "@/views/pages/dashboard/instructor/pages/instructor-quiz.vue";
import InstructorQuizresults from "@/views/pages/dashboard/instructor/pages/instructor-quiz-results.vue";
import InstructorRecommendation from "@/views/pages/dashboard/instructor/pages/instructor-recommendation.vue";

import login from "@/views/pages/auth/login-index.vue";
import otp from "@/views/pages/auth/otp.vue";
import lockScreen from "@/views/pages/auth/lock-screen.vue";
import CourseIndex from "@/views/pages/dashboard/courses/pages/course/course-index.vue";
import CourseGrid from "@/views/pages/dashboard/courses/pages/course/course-grid.vue";
import CourseList from "@/views/pages/dashboard/courses/pages/course/course-list.vue";
import CourseDetails from "@/views/pages/dashboard/courses/pages/details/course-details.vue";
import CoursesIndex from "@/views/pages/dashboard/courses/pages/courses-index.vue";
import CourseResume from "@/views/pages/dashboard/courses/pages/course-resume.vue";
import CourseWatch from "@/views/pages/dashboard/courses/pages/course-watch.vue";
import AddCourse from "@/views/pages/dashboard/courses/pages/add-course/add-course.vue";
import CourseExam from "@/views/pages/dashboard/courses/pages/exam/course-exam.vue";

import StudentIndex from "@/views/pages/dashboard/student/pages/student-index.vue";
import StudentDashboard from "@/views/pages/dashboard/student/pages/student-dashboard.vue";
import StudentProfile from "@/views/pages/dashboard/student/pages/student-profile.vue";
import StudentCourses from "@/views/pages/dashboard/student/pages/student-courses.vue";
import StudentCertificates from "@/views/pages/dashboard/student/pages/student-certificates.vue";
import StudentQuiz from "@/views/pages/dashboard/student/pages/student-quiz.vue";
import StudentQuizQuestions from "@/views/pages/dashboard/student/pages/student-quiz-questions.vue";
import StudentLearningPath from "@/views/pages/dashboard/student/pages/student-learning-path.vue";

//Custom Import

import { useAuthStore } from "@/stores/auth-store";
import { useUIStore } from "@/stores/ui";
import moment from "moment";
import PrincipalIndex from "@/views/pages/dashboard/principal/pages/Principal-index.vue";
import PrincipalDashboard from "@/views/pages/dashboard/principal/pages/Principal-dashboard.vue";
import PrincipalProfile from "@/views/pages/dashboard/principal/pages/Principal-profile.vue";
import PrincipalCourse from "@/views/pages/dashboard/principal/pages/Principal-course.vue";
import PrincipalClassAccessRequest from "@/views/pages/dashboard/principal/pages/Principal-accessRequest.vue";
import PrincipalRemedialRequest from "@/views/pages/dashboard/principal/pages/Principal-remedialRequest.vue";
import PrincipalApproveCourseRequest from "@/views/pages/dashboard/principal/pages/Principal-approveRequest.vue";
import PrincipalUnfinishedCourse from "@/views/pages/dashboard/principal/pages/Principal-UnfinishedCourse.vue";
import GroupPage from "@/views/pages/dashboard/principal/pages/Group-page.vue";
import PrincipalLearningPath from "@/views/pages/dashboard/principal/pages/Principal-learningPath.vue";
import PrincipalCertificates from "@/views/pages/dashboard/principal/pages/Principal-certificates.vue";
import InstructorGrading from "@/views/pages/dashboard/instructor/pages/instructor-grading.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/verify-code/:key",
    name: "code-verify",
    component: otp,
  },
  {
    path: "/otp",
    name: "otp",
    component: otp,
  },
  {
    path: "/lock-screen",
    name: "lock-screen",
    component: lockScreen,
  },
  {
    path: "/coming-soon",
    name: "coming-soon",
    component: comingSoon,
  },
  {
    path: "/under-construction",
    name: "under-construction",
    component: underConstruction,
  },
  {
    path: "/error-500",
    name: "error-500",
    component: error500,
  },
  {
    path: "/error-404",
    name: "error-404",
    component: error404,
  },
  {
    path: "/home",
    name: "Home",
    component: HomeOne,
    children: [{ path: "/", redirect: "/home" }],
  },
  {
    path: "/instructor",
    component: instructorIndex,
    meta: { requiresAuth: true, roles: ["teacher"] },
    children: [
      { path: "", redirect: "/instructor/instructor-dashboard" },
      { path: "instructor-dashboard", component: instructorDashboard },
      { path: "instructor-profile", component: instructorProfile },
      { path: "instructor-course", component: instructorCourse },
      { path: "instructor-exam", component: InstructorQuiz },
      { path: "instructor-recommendation", component: InstructorRecommendation },
      { path: "instructor-learning-path", component: InstructorRecommendation },
      {
        path: "instructor-exam-submission/:examID",
        component: InstructorQuizresults,
        props: true,
      },
      {
        path: "instructor-exam-grading/:submissionID",
        component: InstructorGrading,
        props: true,
      },
    ],
  },
  {
    path: "/course",
    component: CourseIndex,
    children: [
      { path: "", redirect: "/course/course-grid" },
      { path: "course-grid", component: CourseGrid },
      { path: "course-list", component: CourseList },
    ],
  },
  {
    path: "/details/:course_id",
    name: "CourseDetail",
    component: CourseDetails,
    meta: { requiresAuth: true },
    children: [{ path: ":slug", component: CourseDetails }],
  },
  {
    path: "/courses",
    component: CoursesIndex,
    children: [
      { path: "course-resume", component: CourseResume },
      {
        path: "course-watch/:slug",
        component: CourseWatch,
        props: (route) => {
          try {
            const decoded = atob(route.params.slug);
            const [courseID, enrollmentID] = decoded.split("-");
            return {
              courseID: courseID || null,
              enrollmentID:
                enrollmentID && enrollmentID !== "undefined"
                  ? enrollmentID
                  : null,
            };
          } catch (e) {
            console.error("Invalid CourseWatch slug", e);
            return { courseID: null, enrollmentID: null };
          }
        },
        name: "CourseWatch",
      },
      { path: "add-course", component: AddCourse },
      // path untuk course exam
      {
        path: "course-exam/:slug",
        component: CourseExam,
        props: (route) => {
          const decoded = atob(route.params.slug);
          const [courseID, examID] = decoded.split("-");
          return { courseID, examID };
        },
        name: "CourseExam",
      },

      // path untuk grade exam
      {
        path: "course-grade/:submissionID",
        component: CourseExam,
        name: "CourseExamGrade",
      },
      {
        path: "edit/:courseID",
        name: "CourseEdit",
        component: AddCourse,
        props: true,
      },
    ],
  },
  {
    path: "/course-resume/:courseID?",
    component: CourseResume,
    props: true,
    name: "CourseResume",
  },
  {
    path: "/students",
    component: StudentIndex,
    meta: { requiresAuth: true, roles: ["student"] },
    /* meta: { requiresAuth: true }, */
    children: [
      { path: "", redirect: "/students/student-dashboard" },
      { path: "student-dashboard", component: StudentDashboard },
      { path: "student-profile", component: StudentProfile },
      { path: "student-courses", component: StudentCourses },
      { path: "student-certificates", component: StudentCertificates },
      { path: "student-exam", component: StudentQuiz },
      { path: "student-learning-path", component: StudentLearningPath },
      {
        path: "student-exam-detail/:submissionID",
        component: StudentQuizQuestions,
        props: true,
      },
    ],
  },
  {
    path: "/principal",
    component: PrincipalIndex,
    meta: { requiresAuth: true, roles: ["principal"] },
    children: [
      { path: "", redirect: "/principal/dashboard" },
      { path: "dashboard", component: PrincipalDashboard },
      { path: "profile", component: PrincipalProfile },
      { path: "Course", component: PrincipalCourse },
      { path: "Group", component: GroupPage },
      { path: "class-access-request", component: PrincipalClassAccessRequest },
      { path: "remedial-request", component: PrincipalRemedialRequest },
      {
        path: "approve-course-request",
        component: PrincipalApproveCourseRequest,
      },
      { path: "unfinished-course", component: PrincipalUnfinishedCourse },
      { path: "learning-path", component: PrincipalLearningPath },
      { path: "certificates", component: PrincipalCertificates, name: "PrincipalCertificates" },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    redirect: "/error-404",
  },
];

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes,
});

router.beforeEach(async (to, from) => {
  const uiStore = useUIStore();
  uiStore.isLoading = true;

  const auth = useAuthStore();
  const token = localStorage.getItem("token");
  let localUser = null;
  try {
    localUser = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    localUser = null;
  }

  // Inisialisasi role jika belum ada
  if (localUser && token && !auth.role) {
    await auth.authUser();
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiredRoles = to.matched
    .map((record) => record.meta.roles)
    .find((roles) => roles?.length > 0);

  // Belum login atau tidak ada token
  if (requiresAuth && (!localUser || !token)) {
    auth.logout(false);
    return "/login";
  }

  // Sudah login tapi buka /login
  if (to.path === "/login" && localUser && token) {
    return "/home";
  }

  // Cek session expired
  if (requiresAuth && localUser) {
    const usertime = moment(localUser.updated_at).format("LL");
    const timenow = moment().format("LL");
    if (usertime !== timenow) {
      auth.logout(false);
      return "/login";
    }
  }

  // Role tidak sesuai
  if (requiresAuth && requiredRoles && !requiredRoles.includes(String(auth.role || "").toLowerCase())) {
    if (!auth.role) {
      auth.logout(false);
      return "/login";
    }
    return "/error-404";
  }

  return true;  
});

function formatTitleFromName(name) {
  return name.replace(/-/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");
}

router.afterEach((to) => {
  const uiStore = useUIStore();
  uiStore.isLoading = false;

  const defaultTitle = "LMS Business App";
  const suffix = "|| LMS Business APPS";
  const routeName = to.name ? formatTitleFromName(to.name) : null;
  const pageTitle =
    typeof to.meta.title === "string"
      ? to.meta.title
      : routeName || defaultTitle;
  document.title = `${pageTitle} ${suffix}`;

  nextTick(() => {
    AOS.refresh();
  });
});

router.onError((error) => {
  const chunkFailedMessage =
    /Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/;
  if (chunkFailedMessage.test(error.message)) {
    console.warn("Router chunk error, reloading...");
    window.location.reload();
  }
});
